// extracted by mini-css-extract-plugin
module.exports = {"content":"BdrModal_content__2q-Ot","modal":"BdrModal_modal__sQ-Xu","bottom":"BdrModal_bottom__25GRS"};